import React from "react"
import { FaFacebook, FaInstagram } from "react-icons/fa"
const SocialLinks = ({ styleClass }) => {
  return (
    <ul className={styleClass}>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.facebook.com/TheGadgetStoreBD"
        >
          <FaFacebook className="w-4 h-4 inline"> </FaFacebook>
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.instagram.com/gadgetstorebd/"
        >
          <FaInstagram className="w-4 h-4 inline"> </FaInstagram>
        </a>
      </li>
    </ul>
  )
}
export default SocialLinks
